<template>
  <div class="upload">
    <p>(新たに登録するファイルの合計サイズが、約1MB未満まで登録が可能です。)</p>
    <div class="item-container">
      <input-files v-model="form.tenpufiles" name="uploadfile" :input-name="true" name-label="名称" :base-url="baseurl" accept=".png,.jpg,.pdf,.xlsx,.docx" />
    </div>
  </div>
</template>

<script lang="ts">
import Config from "@/const/Config";
import { defineComponent } from "vue";

export default defineComponent({
  props: ["form"],
  setup() {
    return {
      baseurl: Config.THUMB_BASE_URL
    };
  },
});
</script>
